/* ============================================================
   VALCONX THEME — COMPLETE JAVASCRIPT
   ============================================================ */

// ====== TRANSLATIONS — FULL SITE ======
var TRANSLATIONS = {
  nl: {
    /* NAV */
    home:'Home', chairs:'Stoelen', about:'Over', contact:'Contact',
    cart:'Winkelwagen', account:'Account', track:'Bestelling volgen',
    /* ANNOUNCE */
    announce:'🔥 GRATIS VERZENDING op bestellingen boven €299 · Bezorgd binnen 3–5 dagen · LAUNCH KORTING: −18%',
    /* HERO */
    hero_tag:'Collectie 2025',
    hero_h1:'Dominate', hero_h2:'Every Session.',
    hero_sub:'Engineered voor gamers die geen genoegen nemen met minder. Premium comfort, meedogenloos design — gebouwd om te winnen.',
    hero_cta1:'Bekijk collectie →', hero_cta2:'Contact',
    hero_scroll:'Scroll',
    /* TRUST */
    trust1h:'4.9 / 5 beoordeling', trust1s:'Op 4.147 beoordelingen',
    trust2h:'30 dagen retour', trust2s:'Geen vragen, geen gedoe',
    trust3h:'2 jaar garantie', trust3s:'Frame & mechanisme',
    trust4h:'Gratis verzending', trust4s:'NL & BE boven €299',
    /* PROOF BAR */
    pb1:'Verkochte stoelen', pb2:'Gemiddelde score', pb3:'Raadt aan',
    pb4:'EU-landen', pb5:'Reactietijd support',
    /* PRODUCTS */
    feat_tag:'Collectie 2025', feat_h2:'Bestsellers', feat_all:'Alle stoelen →',
    add_cart:'In winkelwagen', badge_new:'Nieuw',
    /* REVIEWS */
    rev_tag:'Klantbeoordelingen', rev_h2:'Wat gamers zeggen',
    rev_score:'Op 4.147 beoordelingen', rev_rec:'96% raadt VALCONX aan',
    rev_verified:'Alle reviews geverifieerd',
    /* FEATURES */
    feat2_tag:'Waarom VALCONX', feat2_h2:'Engineered to Win',
    feat2_sub:'Elk detail zit goed. Van de naad tot het staal.',
    f1t:'Stalen frame', f1tx:'Koudgewalst staal, berekend op 150 kg. Bouwt mee voor jaren zonder doorbuigen of kraken.',
    f2t:'4D armsteunen', f2tx:'Hoogte, breedte, diepte én hoek — volledig naar jouw lichaamshouding instelbaar.',
    f3t:'Memory foam zit', f3tx:'High-density memory foam die zijn vorm behoudt. Geen inzakking na maanden gebruik.',
    f4t:'Lendensteun 3D', f4tx:'Verstelbare lendensteun past zich aan je wervelkolom aan. Minder rugpijn na lange sessies.',
    f5t:'165° kantelhoek', f5tx:'Kantel tot bijna horizontaal, vijfpunts vergrendeling. Van intense gaming tot volledige ontspanning.',
    f6t:'PU wielen 60mm', f6tx:'Stil op parket én tapijt. Beschadigen geen vloeren, draaien 360° soepel.',
    /* NEWSLETTER */
    nl_h:'Blijf op de hoogte', nl_sub:'Nieuwe modellen, exclusieve deals. Geen spam, altijd uitschrijven.',
    nl_placeholder:'jouw@emailadres.nl', nl_btn:'Aanmelden',
    /* FOOTER */
    f_shop:'Shop', f_help:'Hulp', f_company:'Bedrijf',
    f_chairs:'Stoelen', f_accessories:'Accessoires', f_sale:'Sale',
    f_manual:'Handleiding', f_warranty:'Garantie', f_returns:'Retourneren',
    f_track:'Bestelling volgen', f_about:'Over VALCONX', f_privacy:'Privacybeleid', f_terms:'Voorwaarden',
    f_desc:'Premium gaming stoelen voor iedereen die serieus speelt. Ontworpen in Nederland, bezorgd door heel Europa.',
    f_payment:'Veilig betalen met',
    /* CART */
    cart_title:'Winkelwagen', cart_empty:'Je winkelwagen is leeg',
    cart_subtotal:'Subtotaal', cart_checkout:'Afrekenen →',
    cart_note:'Gratis verzending boven €299 · iDEAL · Klarna beschikbaar',
    toast_added:'toegevoegd aan winkelwagen',
    /* CONTACT PAGE */
    contact_tag:'Klantenservice', contact_h1:'Contact',
    contact_sub:'We reageren binnen 24 uur op werkdagen.',
    contact_h2:'Hoe kunnen we helpen?',
    contact_reply:'Reactie binnen 24 uur op werkdagen',
    contact_form_h:'Stuur een bericht',
    fg_first:'Voornaam', fg_last:'Achternaam', fg_email:'E-mailadres',
    fg_order:'Bestelnummer (optioneel)', fg_subject:'Onderwerp', fg_msg:'Bericht',
    fg_send:'Verstuur bericht',
    /* OVER ONS */
    about_tag:'Ons verhaal', about_h1:'Geboren uit frustratie.',
    about_sub:'Te veel gamers zitten op stoelen die niet meekomen. VALCONX is het antwoord: betaalbare luxe, gebouwd om mee te winnen.',
    about_v1h:'Kwaliteit boven alles', about_v1t:'We gebruiken geen goedkope materialen. Elk onderdeel is geselecteerd op duurzaamheid en comfort.',
    about_v2h:'Eerlijke prijs', about_v2t:'Door direct van fabriek te verkopen snijden we de tussenhandel eruit. Meer stoel voor je geld.',
    about_v3h:'Community first', about_v3t:'Elke update aan onze stoelen komt van feedback van echte gebruikers. We luisteren en communiceren eerlijk.',
    about_s1:'Opgericht', about_s2:'Stoelen verkocht', about_s3:'EU landen', about_s4:'Gemiddeld oordeel',
    about_p_tag:'Hoe we bouwen', about_p_h2:'Onze aanpak', about_p_sub:'Vier principes staan centraal.',
    about_p1h:'Direct van fabriek', about_p1t:'We werken rechtstreeks met productiepartners. Premium materialen zonder premium prijzen.',
    about_p2h:'Ontworpen door gamers', about_p2t:'Elk model is ontwikkeld samen met de gaming community. Maanden van testen.',
    about_p3h:'Transparante service', about_p3t:'30 dagen retour. 2 jaar garantie. Klantenservice reageert binnen 24 uur.',
    about_p4h:'Continu verbeteren', about_p4t:'Elke generatie VALCONX is beter dan de vorige. We voeren twee keer per jaar verbeteringen door.',
    track_tag:'Klantenservice', track_h1:'Bestelling volgen', track_sub:'Voer je bestelnummer en e-mailadres in.',
    track_form_h:'Waar is mijn bestelling?', track_form_sub:'Je ontvangt ook automatisch een Track & Trace e-mail zodra je pakket verzonden is.',
    track_order_nr:'Bestelnummer', track_order_hint:'Staat in je bevestigingsmail, bijv. #VCX-2025-00123',
    track_email:'E-mailadres', track_email_hint:'Het e-mailadres waarmee je hebt besteld',
    track_btn:'Bestelling zoeken →', track_not_found:'Geen bestelling gevonden. Controleer je bestelnummer en e-mailadres.',
    track_new:'Nieuw zoeken', track_code_label:'Track & Trace code', track_follow:'Volg pakket →',
    track_help_prefix:'Hulp nodig?', track_help_link:'Neem contact op', track_help_suffix:'— we reageren binnen 24 uur.',
    ts_confirmed:'Bevestigd', ts_processing:'Verwerkt', ts_shipped:'Verzonden', ts_transit:'Onderweg', ts_delivered:'Bezorgd',
    fg_subj1:'Vraag over een product', fg_subj2:'Bestelling & levering', fg_subj3:'Retour & garantie', fg_subj4:'Technisch probleem', fg_subj5:'Anders',
    /* COLLECTION */
    coll_title:'Gaming Stoelen',
    coll_sub:'Engineered voor gamers die geen genoegen nemen met minder. Premium comfort, 2 jaar garantie, gratis retour.',
    coll_filter_all:'Alle', coll_filter_racing:'Racing', coll_filter_pro:'Pro Series', coll_filter_xl:'XL', coll_filter_sale:'Sale',
    coll_compare:'Vergelijk stoelen ↓', coll_help:'Welke stoel past bij jou?',
    coll_help_sub:'Gebruik onze vergelijkingstabel onderaan de pagina.',
  },
  en: {
    home:'Home', chairs:'Chairs', about:'About', contact:'Contact',
    cart:'Cart', account:'Account', track:'Track order',
    announce:'🔥 FREE SHIPPING on orders over €299 · Delivered in 3–5 days · LAUNCH DISCOUNT: −18%',
    hero_tag:'Collection 2025',
    hero_h1:'Dominate', hero_h2:'Every Session.',
    hero_sub:'Engineered for gamers who refuse to settle for less. Premium comfort, relentless design — built to win.',
    hero_cta1:'Shop collection →', hero_cta2:'Contact',
    hero_scroll:'Scroll',
    trust1h:'4.9 / 5 rating', trust1s:'On 4,147 reviews',
    trust2h:'30-day returns', trust2s:'No questions asked',
    trust3h:'2-year warranty', trust3s:'Frame & mechanism',
    trust4h:'Free shipping', trust4s:'EU orders over €299',
    pb1:'Chairs sold', pb2:'Average rating', pb3:'Recommend',
    pb4:'EU countries', pb5:'Support response',
    feat_tag:'Collection 2025', feat_h2:'Bestsellers', feat_all:'All chairs →',
    add_cart:'Add to cart', badge_new:'New',
    rev_tag:'Customer reviews', rev_h2:'What gamers say',
    rev_score:'On 4,147 reviews', rev_rec:'96% recommend VALCONX',
    rev_verified:'All reviews verified',
    feat2_tag:'Why VALCONX', feat2_h2:'Engineered to Win',
    feat2_sub:'Every detail is right. From the stitch to the steel.',
    f1t:'Steel frame', f1tx:'Cold-rolled steel, rated at 150 kg. Built to last years without bending.',
    f2t:'4D armrests', f2tx:'Height, width, depth and angle — fully adjustable to your body posture.',
    f3t:'Memory foam seat', f3tx:'High-density memory foam that holds its shape. No sagging after months of use.',
    f4t:'3D lumbar support', f4tx:'Adjustable lumbar support adapts to your spine. Less back pain after long sessions.',
    f5t:'165° recline', f5tx:'Recline to almost flat, five-point lock at every 15°. Gaming to full relaxation.',
    f6t:'PU wheels 60mm', f6tx:'Silent on hardwood and carpet. No scratches, smooth 360° in all directions.',
    nl_h:'Stay updated', nl_sub:'New models, exclusive deals. No spam, unsubscribe anytime.',
    nl_placeholder:'your@email.com', nl_btn:'Subscribe',
    f_shop:'Shop', f_help:'Help', f_company:'Company',
    f_chairs:'Chairs', f_accessories:'Accessories', f_sale:'Sale',
    f_manual:'Assembly guide', f_warranty:'Warranty', f_returns:'Returns',
    f_track:'Track order', f_about:'About VALCONX', f_privacy:'Privacy policy', f_terms:'Terms',
    f_desc:'Premium gaming chairs for everyone who plays seriously. Designed in the Netherlands, delivered across Europe.',
    f_payment:'Secure payment with',
    cart_title:'Cart', cart_empty:'Your cart is empty',
    cart_subtotal:'Subtotal', cart_checkout:'Checkout →',
    cart_note:'Free shipping over €299 · iDEAL · Klarna available',
    toast_added:'added to cart',
    contact_tag:'Customer service', contact_h1:'Contact',
    contact_sub:'We respond within 24 hours on business days.',
    contact_h2:'How can we help?',
    contact_reply:'Response within 24 hours',
    contact_form_h:'Send a message',
    fg_first:'First name', fg_last:'Last name', fg_email:'Email address',
    fg_order:'Order number (optional)', fg_subject:'Subject', fg_msg:'Message',
    fg_send:'Send message',
    about_tag:'Our story', about_h1:'Born from frustration.',
    about_sub:'Too many gamers sit on chairs that don\'t keep up. VALCONX is the answer: affordable luxury, built to win.',
    about_v1h:'Quality above all', about_v1t:'We use no cheap materials. Every component is selected for durability and comfort.',
    about_v2h:'Fair price', about_v2t:'By selling direct from factory we cut out the middleman. More chair for your money.',
    about_v3h:'Community first', about_v3t:'Every update to our chairs comes from real user feedback. We listen and communicate honestly.',
    about_s1:'Founded', about_s2:'Chairs sold', about_s3:'EU countries', about_s4:'Average rating',
    about_p_tag:'How we build', about_p_h2:'Our approach', about_p_sub:'Four principles are central to everything we do.',
    about_p1h:'Direct from factory', about_p1t:'We work directly with production partners. Premium materials without premium prices.',
    about_p2h:'Designed by gamers', about_p2t:'Every model developed with the gaming community. Months of testing.',
    about_p3h:'Transparent service', about_p3t:'30-day returns. 2-year warranty. Support responds within 24 hours.',
    about_p4h:'Continuous improvement', about_p4t:'Every VALCONX generation is better than the last. We make improvements twice a year.',
    track_tag:'Customer service', track_h1:'Track order', track_sub:'Enter your order number and email to track your order.',
    track_form_h:'Where is my order?', track_form_sub:'You also receive a Track & Trace email automatically once your package ships.',
    track_order_nr:'Order number', track_order_hint:'Found in your confirmation email, e.g. #VCX-2025-00123',
    track_email:'Email address', track_email_hint:'The email address you used to order',
    track_btn:'Find order →', track_not_found:'No order found. Check your order number and email address.',
    track_new:'New search', track_code_label:'Tracking code', track_follow:'Track package →',
    track_help_prefix:'Need help?', track_help_link:'Contact us', track_help_suffix:'— we respond within 24 hours.',
    ts_confirmed:'Confirmed', ts_processing:'Processing', ts_shipped:'Shipped', ts_transit:'In transit', ts_delivered:'Delivered',
    fg_subj1:'Product question', fg_subj2:'Order & delivery', fg_subj3:'Return & warranty', fg_subj4:'Technical issue', fg_subj5:'Other',
    coll_title:'Gaming Chairs',
    coll_sub:'Engineered for gamers who refuse to settle for less. Premium comfort, 2-year warranty, free returns.',
    coll_filter_all:'All', coll_filter_racing:'Racing', coll_filter_pro:'Pro Series', coll_filter_xl:'XL', coll_filter_sale:'Sale',
    coll_compare:'Compare chairs ↓', coll_help:'Which chair suits you?',
    coll_help_sub:'Use our comparison table at the bottom of the page.',
  },
  fr: {
    home:'Accueil', chairs:'Chaises', about:'À propos', contact:'Contact',
    cart:'Panier', account:'Compte', track:'Suivi commande',
    announce:'🔥 LIVRAISON GRATUITE pour les commandes supérieures à €299 · Livraison en 3–5 jours · REMISE: −18%',
    hero_tag:'Collection 2025',
    hero_h1:'Dominez', hero_h2:'Chaque Session.',
    hero_sub:'Conçu pour les gamers qui n\'acceptent pas moins. Confort premium, design implacable — fait pour gagner.',
    hero_cta1:'Voir la collection →', hero_cta2:'Contact',
    hero_scroll:'Défiler',
    trust1h:'Note 4,9 / 5', trust1s:'Sur 4 147 avis',
    trust2h:'30 jours de retour', trust2s:'Sans questions',
    trust3h:'2 ans de garantie', trust3s:'Cadre & mécanisme',
    trust4h:'Livraison gratuite', trust4s:'UE commandes +€299',
    pb1:'Chaises vendues', pb2:'Note moyenne', pb3:'Recommandent',
    pb4:'Pays UE', pb5:'Réponse support',
    feat_tag:'Collection 2025', feat_h2:'Meilleures ventes', feat_all:'Toutes les chaises →',
    add_cart:'Ajouter au panier', badge_new:'Nouveau',
    rev_tag:'Avis clients', rev_h2:'Ce que disent les gamers',
    rev_score:'Sur 4 147 avis', rev_rec:'96% recommandent VALCONX',
    rev_verified:'Tous les avis vérifiés',
    feat2_tag:'Pourquoi VALCONX', feat2_h2:'Engineered to Win',
    feat2_sub:'Chaque détail est soigné. De la couture à l\'acier.',
    f1t:'Châssis acier', f1tx:'Acier laminé à froid, 150 kg. Construit pour durer des années.',
    f2t:'Accoudoirs 4D', f2tx:'Hauteur, largeur, profondeur et angle — entièrement réglables.',
    f3t:'Siège memory foam', f3tx:'Mousse haute densité qui conserve sa forme. Aucun affaissement.',
    f4t:'Soutien lombaire 3D', f4tx:'S\'adapte à votre colonne vertébrale. Moins de douleurs.',
    f5t:'Inclinaison 165°', f5tx:'Inclinaison jusqu\'à presque horizontal, verrouillage à 5 points.',
    f6t:'Roulettes PU 60mm', f6tx:'Silencieuses sur parquet et moquette. Aucune rayure.',
    nl_h:'Restez informé', nl_sub:'Nouveaux modèles, offres exclusives. Pas de spam.',
    nl_placeholder:'votre@email.fr', nl_btn:'S\'inscrire',
    f_shop:'Boutique', f_help:'Aide', f_company:'Entreprise',
    f_chairs:'Chaises', f_accessories:'Accessoires', f_sale:'Soldes',
    f_manual:'Guide montage', f_warranty:'Garantie', f_returns:'Retours',
    f_track:'Suivre commande', f_about:'À propos', f_privacy:'Confidentialité', f_terms:'Conditions',
    f_desc:'Chaises gaming premium pour tous ceux qui jouent sérieusement. Conçues aux Pays-Bas, livrées dans toute l\'Europe.',
    f_payment:'Paiement sécurisé avec',
    cart_title:'Panier', cart_empty:'Votre panier est vide',
    cart_subtotal:'Sous-total', cart_checkout:'Commander →',
    cart_note:'Livraison gratuite +€299 · Klarna disponible',
    toast_added:'ajouté au panier',
    contact_tag:'Service client', contact_h1:'Contact',
    contact_sub:'Nous répondons dans les 24 heures.',
    contact_h2:'Comment pouvons-nous vous aider?',
    contact_reply:'Réponse dans les 24 heures',
    contact_form_h:'Envoyer un message',
    fg_first:'Prénom', fg_last:'Nom', fg_email:'Adresse e-mail',
    fg_order:'Numéro de commande (optionnel)', fg_subject:'Sujet', fg_msg:'Message',
    fg_send:'Envoyer le message',
    about_tag:'Notre histoire', about_h1:'Né de la frustration.',
    about_sub:'Trop de gamers utilisent des chaises inadaptées. VALCONX est la réponse: luxe accessible, fait pour gagner.',
    about_v1h:'La qualité avant tout', about_v1t:'Nous utilisons des matériaux premium. Chaque composant est sélectionné pour sa durabilité.',
    about_v2h:'Prix honnête', about_v2t:'En vendant directement depuis l\'usine, nous éliminons les intermédiaires.',
    about_v3h:'Communauté d\'abord', about_v3t:'Chaque mise à jour vient des retours de vrais utilisateurs.',
    about_s1:'Fondé', about_s2:'Chaises vendues', about_s3:'Pays UE', about_s4:'Note moyenne',
    about_p_tag:'Comment nous construisons', about_p_h2:'Notre approche', about_p_sub:'Quatre principes au cœur de tout.',
    about_p1h:'Direct d\'usine', about_p1t:'Nous travaillons directement avec les partenaires de production.',
    about_p2h:'Conçu par des gamers', about_p2t:'Chaque modèle développé avec la communauté gaming.',
    about_p3h:'Service transparent', about_p3t:'30 jours de retour. 2 ans de garantie. Support en 24h.',
    about_p4h:'Amélioration continue', about_p4t:'Chaque génération VALCONX est meilleure que la précédente.',
    fg_subj1:'Question produit', fg_subj2:'Commande & livraison', fg_subj3:'Retour & garantie', fg_subj4:'Problème technique', fg_subj5:'Autre',
    coll_title:'Chaises Gaming',
    coll_sub:'Conçues pour les gamers exigeants. Confort premium, garantie 2 ans, retours gratuits.',
    coll_filter_all:'Tous', coll_filter_racing:'Racing', coll_filter_pro:'Pro Series', coll_filter_xl:'XL', coll_filter_sale:'Soldes',
    coll_compare:'Comparer les chaises ↓', coll_help:'Quelle chaise vous convient?',
    coll_help_sub:'Utilisez notre tableau comparatif en bas de page.',
  },
  de: {
    home:'Startseite', chairs:'Stühle', about:'Über uns', contact:'Kontakt',
    cart:'Warenkorb', account:'Konto', track:'Bestellung verfolgen',
    announce:'🔥 KOSTENLOSER VERSAND ab €299 · Lieferung in 3–5 Tagen · RABATT: −18%',
    hero_tag:'Kollektion 2025',
    hero_h1:'Dominiere', hero_h2:'Jede Session.',
    hero_sub:'Entwickelt für Gamer, die keine Kompromisse eingehen. Premium-Komfort, gnadenloses Design — zum Siegen gebaut.',
    hero_cta1:'Kollektion ansehen →', hero_cta2:'Kontakt',
    hero_scroll:'Scrollen',
    trust1h:'4,9 / 5 Bewertung', trust1s:'Bei 4.147 Bewertungen',
    trust2h:'30 Tage Rückgabe', trust2s:'Keine Fragen gestellt',
    trust3h:'2 Jahre Garantie', trust3s:'Rahmen & Mechanismus',
    trust4h:'Kostenloser Versand', trust4s:'EU ab €299',
    pb1:'Verkaufte Stühle', pb2:'Ø Bewertung', pb3:'Empfehlen',
    pb4:'EU-Länder', pb5:'Support-Reaktion',
    feat_tag:'Kollektion 2025', feat_h2:'Bestseller', feat_all:'Alle Stühle →',
    add_cart:'In den Warenkorb', badge_new:'Neu',
    rev_tag:'Kundenbewertungen', rev_h2:'Was Gamer sagen',
    rev_score:'Bei 4.147 Bewertungen', rev_rec:'96% empfehlen VALCONX',
    rev_verified:'Alle Bewertungen verifiziert',
    feat2_tag:'Warum VALCONX', feat2_h2:'Engineered to Win',
    feat2_sub:'Jedes Detail stimmt. Von der Naht bis zum Stahl.',
    f1t:'Stahlrahmen', f1tx:'Kaltgewalzter Stahl, 150 kg belastbar. Jahrelang ohne Verbiegen.',
    f2t:'4D-Armlehnen', f2tx:'Höhe, Breite, Tiefe und Winkel — vollständig einstellbar.',
    f3t:'Memory-Schaum-Sitz', f3tx:'Hochdichter Schaumstoff behält seine Form. Kein Einsinken.',
    f4t:'3D-Lendenwirbelstütze', f4tx:'Passt sich deiner Wirbelsäule an. Weniger Rückenschmerzen.',
    f5t:'165° Neigung', f5tx:'Neigung bis fast horizontal, 5-Punkt-Verriegelung alle 15°.',
    f6t:'PU-Rollen 60mm', f6tx:'Leise auf Parkett und Teppich. Keine Kratzer, 360° drehbar.',
    nl_h:'Bleib auf dem Laufenden', nl_sub:'Neue Modelle, exklusive Angebote. Kein Spam.',
    nl_placeholder:'deine@email.de', nl_btn:'Anmelden',
    f_shop:'Shop', f_help:'Hilfe', f_company:'Unternehmen',
    f_chairs:'Stühle', f_accessories:'Zubehör', f_sale:'Sale',
    f_manual:'Montageanleitung', f_warranty:'Garantie', f_returns:'Rückgabe',
    f_track:'Bestellung verfolgen', f_about:'Über VALCONX', f_privacy:'Datenschutz', f_terms:'AGB',
    f_desc:'Premium-Gaming-Stühle für alle, die es ernst nehmen. In den Niederlanden entworfen, europaweit geliefert.',
    f_payment:'Sicher bezahlen mit',
    cart_title:'Warenkorb', cart_empty:'Dein Warenkorb ist leer',
    cart_subtotal:'Zwischensumme', cart_checkout:'Zur Kasse →',
    cart_note:'Kostenloser Versand ab €299 · Klarna verfügbar',
    toast_added:'in den Warenkorb gelegt',
    contact_tag:'Kundenservice', contact_h1:'Kontakt',
    contact_sub:'Wir antworten innerhalb von 24 Stunden.',
    contact_h2:'Wie können wir helfen?',
    contact_reply:'Antwort innerhalb von 24 Stunden',
    contact_form_h:'Nachricht senden',
    fg_first:'Vorname', fg_last:'Nachname', fg_email:'E-Mail-Adresse',
    fg_order:'Bestellnummer (optional)', fg_subject:'Betreff', fg_msg:'Nachricht',
    fg_send:'Nachricht senden',
    about_tag:'Unsere Geschichte', about_h1:'Aus Frustration geboren.',
    about_sub:'Zu viele Gamer sitzen auf unzureichenden Stühlen. VALCONX ist die Antwort: erschwinglicher Luxus, zum Siegen gebaut.',
    about_v1h:'Qualität über alles', about_v1t:'Wir verwenden keine Billigmaterialien. Jedes Bauteil ist auf Langlebigkeit ausgewählt.',
    about_v2h:'Fairer Preis', about_v2t:'Durch Direktverkauf ab Werk sparen wir den Zwischenhandel ein.',
    about_v3h:'Community zuerst', about_v3t:'Jedes Update kommt vom Feedback echter Nutzer.',
    about_s1:'Gegründet', about_s2:'Stühle verkauft', about_s3:'EU-Länder', about_s4:'Ø Bewertung',
    about_p_tag:'Wie wir bauen', about_p_h2:'Unser Ansatz', about_p_sub:'Vier Prinzipien stehen im Mittelpunkt.',
    about_p1h:'Direkt ab Werk', about_p1t:'Wir arbeiten direkt mit Produktionspartnern. Premium ohne Aufpreis.',
    about_p2h:'Von Gamern designed', about_p2t:'Jedes Modell mit der Gaming-Community entwickelt.',
    about_p3h:'Transparenter Service', about_p3t:'30 Tage Rückgabe. 2 Jahre Garantie. Support in 24h.',
    about_p4h:'Kontinuierliche Verbesserung', about_p4t:'Jede VALCONX-Generation ist besser als die vorherige.',
    fg_subj1:'Produktfrage', fg_subj2:'Bestellung & Lieferung', fg_subj3:'Rückgabe & Garantie', fg_subj4:'Technisches Problem', fg_subj5:'Sonstiges',
    coll_title:'Gaming-Stühle',
    coll_sub:'Entwickelt für Gamer ohne Kompromisse. Premium-Komfort, 2 Jahre Garantie, kostenlose Rückgabe.',
    coll_filter_all:'Alle', coll_filter_racing:'Racing', coll_filter_pro:'Pro Series', coll_filter_xl:'XL', coll_filter_sale:'Sale',
    coll_compare:'Stühle vergleichen ↓', coll_help:'Welcher Stuhl passt zu dir?',
    coll_help_sub:'Nutze unsere Vergleichstabelle am Ende der Seite.',
  },
  es: {
    home:'Inicio', chairs:'Sillas', about:'Nosotros', contact:'Contacto',
    cart:'Carrito', account:'Cuenta', track:'Seguir pedido',
    announce:'🔥 ENVÍO GRATUITO en pedidos superiores a €299 · Entrega en 3–5 días · DESCUENTO: −18%',
    hero_tag:'Colección 2025',
    hero_h1:'Domina', hero_h2:'Cada Sesión.',
    hero_sub:'Diseñado para gamers que no aceptan menos. Confort premium, diseño implacable — hecho para ganar.',
    hero_cta1:'Ver colección →', hero_cta2:'Contacto',
    hero_scroll:'Desplazar',
    trust1h:'Valoración 4,9 / 5', trust1s:'En 4.147 reseñas',
    trust2h:'30 días de devolución', trust2s:'Sin preguntas',
    trust3h:'2 años de garantía', trust3s:'Chasis y mecanismo',
    trust4h:'Envío gratuito', trust4s:'UE pedidos +€299',
    pb1:'Sillas vendidas', pb2:'Puntuación media', pb3:'Recomienda',
    pb4:'Países UE', pb5:'Respuesta soporte',
    feat_tag:'Colección 2025', feat_h2:'Más vendidos', feat_all:'Todas las sillas →',
    add_cart:'Añadir al carrito', badge_new:'Nuevo',
    rev_tag:'Reseñas de clientes', rev_h2:'Lo que dicen los gamers',
    rev_score:'En 4.147 reseñas', rev_rec:'96% recomienda VALCONX',
    rev_verified:'Todas las reseñas verificadas',
    feat2_tag:'Por qué VALCONX', feat2_h2:'Engineered to Win',
    feat2_sub:'Cada detalle está cuidado. Del hilo al acero.',
    f1t:'Chasis de acero', f1tx:'Acero laminado en frío, 150 kg. Construido para durar años.',
    f2t:'Reposabrazos 4D', f2tx:'Altura, anchura, profundidad y ángulo — totalmente ajustables.',
    f3t:'Asiento memory foam', f3tx:'Espuma de alta densidad que mantiene su forma. Sin hundimiento.',
    f4t:'Soporte lumbar 3D', f4tx:'Se adapta a tu columna vertebral. Menos dolor de espalda.',
    f5t:'Inclinación 165°', f5tx:'Inclinación hasta casi horizontal, bloqueo en 5 puntos.',
    f6t:'Ruedas PU 60mm', f6tx:'Silenciosas en parquet y moqueta. Sin arañazos, giran 360°.',
    nl_h:'Mantente informado', nl_sub:'Nuevos modelos, ofertas exclusivas. Sin spam.',
    nl_placeholder:'tu@email.es', nl_btn:'Suscribirse',
    f_shop:'Tienda', f_help:'Ayuda', f_company:'Empresa',
    f_chairs:'Sillas', f_accessories:'Accesorios', f_sale:'Oferta',
    f_manual:'Guía de montaje', f_warranty:'Garantía', f_returns:'Devoluciones',
    f_track:'Seguir pedido', f_about:'Sobre VALCONX', f_privacy:'Privacidad', f_terms:'Términos',
    f_desc:'Sillas gaming premium para quienes juegan en serio. Diseñadas en Países Bajos, entregadas en toda Europa.',
    f_payment:'Pago seguro con',
    cart_title:'Carrito', cart_empty:'Tu carrito está vacío',
    cart_subtotal:'Subtotal', cart_checkout:'Pagar →',
    cart_note:'Envío gratuito a partir de €299 · Klarna disponible',
    toast_added:'añadido al carrito',
    contact_tag:'Servicio al cliente', contact_h1:'Contacto',
    contact_sub:'Respondemos en 24 horas.',
    contact_h2:'¿Cómo podemos ayudar?',
    contact_reply:'Respuesta en 24 horas',
    contact_form_h:'Enviar un mensaje',
    fg_first:'Nombre', fg_last:'Apellido', fg_email:'Correo electrónico',
    fg_order:'Número de pedido (opcional)', fg_subject:'Asunto', fg_msg:'Mensaje',
    fg_send:'Enviar mensaje',
    about_tag:'Nuestra historia', about_h1:'Nacido de la frustración.',
    about_sub:'Demasiados gamers usan sillas inadecuadas. VALCONX es la respuesta: lujo asequible, hecho para ganar.',
    about_v1h:'Calidad ante todo', about_v1t:'Usamos materiales premium. Cada componente seleccionado por durabilidad.',
    about_v2h:'Precio justo', about_v2t:'Vendiendo directamente de fábrica eliminamos intermediarios.',
    about_v3h:'Comunidad primero', about_v3t:'Cada actualización viene del feedback de usuarios reales.',
    about_s1:'Fundado', about_s2:'Sillas vendidas', about_s3:'Países UE', about_s4:'Valoración media',
    about_p_tag:'Cómo construimos', about_p_h2:'Nuestro enfoque', about_p_sub:'Cuatro principios en el centro de todo.',
    about_p1h:'Directo de fábrica', about_p1t:'Trabajamos directamente con socios de producción.',
    about_p2h:'Diseñado por gamers', about_p2t:'Cada modelo desarrollado con la comunidad gaming.',
    about_p3h:'Servicio transparente', about_p3t:'30 días devolución. 2 años garantía. Soporte en 24h.',
    about_p4h:'Mejora continua', about_p4t:'Cada generación VALCONX es mejor que la anterior.',
    fg_subj1:'Pregunta de producto', fg_subj2:'Pedido & envío', fg_subj3:'Devolución & garantía', fg_subj4:'Problema técnico', fg_subj5:'Otro',
    coll_title:'Sillas Gaming',
    coll_sub:'Diseñadas para gamers exigentes. Confort premium, garantía 2 años, devoluciones gratuitas.',
    coll_filter_all:'Todas', coll_filter_racing:'Racing', coll_filter_pro:'Pro Series', coll_filter_xl:'XL', coll_filter_sale:'Oferta',
    coll_compare:'Comparar sillas ↓', coll_help:'¿Qué silla te conviene?',
    coll_help_sub:'Usa nuestra tabla comparativa al final de la página.',
  },
  it: {
    home:'Home', chairs:'Sedie', about:'Chi siamo', contact:'Contatto',
    cart:'Carrello', account:'Account', track:'Traccia ordine',
    announce:'🔥 SPEDIZIONE GRATUITA per ordini superiori a €299 · Consegna in 3–5 giorni · SCONTO: −18%',
    hero_tag:'Collezione 2025',
    hero_h1:'Domina', hero_h2:'Ogni Sessione.',
    hero_sub:'Progettato per i gamer che non accettano compromessi. Comfort premium, design senza pietà — costruito per vincere.',
    hero_cta1:'Vedi collezione →', hero_cta2:'Contatto',
    hero_scroll:'Scorri',
    trust1h:'Valutazione 4,9 / 5', trust1s:'Su 4.147 recensioni',
    trust2h:'30 giorni di reso', trust2s:'Senza domande',
    trust3h:'2 anni di garanzia', trust3s:'Telaio e meccanismo',
    trust4h:'Spedizione gratuita', trust4s:'UE ordini +€299',
    pb1:'Sedie vendute', pb2:'Valutazione media', pb3:'Consiglia',
    pb4:'Paesi UE', pb5:'Risposta supporto',
    feat_tag:'Collezione 2025', feat_h2:'Più venduti', feat_all:'Tutte le sedie →',
    add_cart:'Aggiungi al carrello', badge_new:'Nuovo',
    rev_tag:'Recensioni clienti', rev_h2:'Cosa dicono i gamer',
    rev_score:'Su 4.147 recensioni', rev_rec:'96% consiglia VALCONX',
    rev_verified:'Tutte le recensioni verificate',
    feat2_tag:'Perché VALCONX', feat2_h2:'Engineered to Win',
    feat2_sub:'Ogni dettaglio è curato. Dal punto all\'acciaio.',
    f1t:'Telaio in acciaio', f1tx:'Acciaio laminato a freddo, 150 kg. Costruito per durare anni.',
    f2t:'Braccioli 4D', f2tx:'Altezza, larghezza, profondità e angolo — completamente regolabili.',
    f3t:'Seduta in memory foam', f3tx:'Schiuma ad alta densità che mantiene la forma. Nessun affossamento.',
    f4t:'Supporto lombare 3D', f4tx:'Si adatta alla tua colonna vertebrale. Meno dolori.',
    f5t:'Inclinazione 165°', f5tx:'Inclinazione fino a quasi orizzontale, blocco a 5 punti.',
    f6t:'Ruote PU 60mm', f6tx:'Silenziose su parquet e moquette. Nessun graffio, 360° fluide.',
    nl_h:'Resta aggiornato', nl_sub:'Nuovi modelli, offerte esclusive. Niente spam.',
    nl_placeholder:'tua@email.it', nl_btn:'Iscriviti',
    f_shop:'Negozio', f_help:'Assistenza', f_company:'Azienda',
    f_chairs:'Sedie', f_accessories:'Accessori', f_sale:'Offerte',
    f_manual:'Guida montaggio', f_warranty:'Garanzia', f_returns:'Resi',
    f_track:'Traccia ordine', f_about:'Chi siamo', f_privacy:'Privacy', f_terms:'Termini',
    f_desc:'Sedie gaming premium per chi gioca seriamente. Progettate in Olanda, consegnate in tutta Europa.',
    f_payment:'Pagamento sicuro con',
    cart_title:'Carrello', cart_empty:'Il tuo carrello è vuoto',
    cart_subtotal:'Subtotale', cart_checkout:'Vai al checkout →',
    cart_note:'Spedizione gratuita oltre €299 · Klarna disponibile',
    toast_added:'aggiunto al carrello',
    contact_tag:'Servizio clienti', contact_h1:'Contatto',
    contact_sub:'Rispondiamo entro 24 ore.',
    contact_h2:'Come possiamo aiutarti?',
    contact_reply:'Risposta entro 24 ore',
    contact_form_h:'Invia un messaggio',
    fg_first:'Nome', fg_last:'Cognome', fg_email:'Indirizzo email',
    fg_order:'Numero ordine (opzionale)', fg_subject:'Oggetto', fg_msg:'Messaggio',
    fg_send:'Invia messaggio',
    about_tag:'La nostra storia', about_h1:'Nato dalla frustrazione.',
    about_sub:'Troppi gamer usano sedie inadeguate. VALCONX è la risposta: lusso accessibile, costruito per vincere.',
    about_v1h:'Qualità prima di tutto', about_v1t:'Usiamo materiali premium. Ogni componente selezionato per durabilità.',
    about_v2h:'Prezzo onesto', about_v2t:'Vendendo direttamente dalla fabbrica eliminiamo gli intermediari.',
    about_v3h:'Community prima', about_v3t:'Ogni aggiornamento viene dal feedback degli utenti reali.',
    about_s1:'Fondata', about_s2:'Sedie vendute', about_s3:'Paesi UE', about_s4:'Valutazione media',
    about_p_tag:'Come costruiamo', about_p_h2:'Il nostro approccio', about_p_sub:'Quattro principi al centro di tutto.',
    about_p1h:'Direttamente dalla fabbrica', about_p1t:'Lavoriamo direttamente con i partner di produzione.',
    about_p2h:'Progettato dai gamer', about_p2t:'Ogni modello sviluppato con la gaming community.',
    about_p3h:'Servizio trasparente', about_p3t:'30 giorni di reso. 2 anni di garanzia. Supporto in 24h.',
    about_p4h:'Miglioramento continuo', about_p4t:'Ogni generazione VALCONX è migliore della precedente.',
    fg_subj1:'Domanda prodotto', fg_subj2:'Ordine & spedizione', fg_subj3:'Reso & garanzia', fg_subj4:'Problema tecnico', fg_subj5:'Altro',
    coll_title:'Sedie Gaming',
    coll_sub:'Progettate per gamer esigenti. Comfort premium, garanzia 2 anni, resi gratuiti.',
    coll_filter_all:'Tutte', coll_filter_racing:'Racing', coll_filter_pro:'Pro Series', coll_filter_xl:'XL', coll_filter_sale:'Offerte',
    coll_compare:'Confronta sedie ↓', coll_help:'Quale sedia fa per te?',
    coll_help_sub:'Usa la nostra tabella comparativa in fondo alla pagina.',
  },
  sv: {
    home:'Hem', chairs:'Stolar', about:'Om oss', contact:'Kontakt',
    cart:'Varukorg', account:'Konto', track:'Spåra order',
    announce:'🔥 GRATIS FRAKT på beställningar över €299 · Leverans inom 3–5 dagar · RABATT: −18%',
    hero_tag:'Kollektion 2025',
    hero_h1:'Dominera', hero_h2:'Varje Session.',
    hero_sub:'Engineered för spelare som inte nöjer sig med mindre. Premium komfort, obeveklig design — byggd för att vinna.',
    hero_cta1:'Se kollektion →', hero_cta2:'Kontakt',
    hero_scroll:'Scrolla',
    trust1h:'4,9 / 5 betyg', trust1s:'På 4 147 recensioner',
    trust2h:'30 dagars retur', trust2s:'Inga frågor',
    trust3h:'2 års garanti', trust3s:'Ram och mekanism',
    trust4h:'Gratis frakt', trust4s:'EU beställningar +€299',
    pb1:'Sålda stolar', pb2:'Genomsnittsbetyg', pb3:'Rekommenderar',
    pb4:'EU-länder', pb5:'Supportrespons',
    feat_tag:'Kollektion 2025', feat_h2:'Bästsäljare', feat_all:'Alla stolar →',
    add_cart:'Lägg i varukorg', badge_new:'Ny',
    rev_tag:'Kundrecensioner', rev_h2:'Vad spelare säger',
    rev_score:'På 4 147 recensioner', rev_rec:'96% rekommenderar VALCONX',
    rev_verified:'Alla recensioner verifierade',
    feat2_tag:'Varför VALCONX', feat2_h2:'Engineered to Win',
    feat2_sub:'Varje detalj är rätt. Från söm till stål.',
    f1t:'Stålram', f1tx:'Kallvalsat stål, 150 kg. Byggd för att hålla i år utan att ge vika.',
    f2t:'4D-armstöd', f2tx:'Höjd, bredd, djup och vinkel — fullt justerbara.',
    f3t:'Memory foam-sits', f3tx:'Högdensitet memory foam som håller sin form. Ingen nedsänkning.',
    f4t:'3D ländrygsstöd', f4tx:'Anpassar sig till din ryggrad. Mindre ryggsmärta.',
    f5t:'165° lutning', f5tx:'Luta till nästan horisontellt, 5-punktslås var 15°.',
    f6t:'PU-hjul 60mm', f6tx:'Tysta på parkett och heltäckande. Inga repor, 360° smidiga.',
    nl_h:'Håll dig uppdaterad', nl_sub:'Nya modeller, exklusiva erbjudanden. Ingen spam.',
    nl_placeholder:'din@email.se', nl_btn:'Prenumerera',
    f_shop:'Shop', f_help:'Hjälp', f_company:'Företag',
    f_chairs:'Stolar', f_accessories:'Tillbehör', f_sale:'Rea',
    f_manual:'Monteringsguide', f_warranty:'Garanti', f_returns:'Returer',
    f_track:'Spåra order', f_about:'Om VALCONX', f_privacy:'Integritetspolicy', f_terms:'Villkor',
    f_desc:'Premium gamingstolar för alla som spelar på allvar. Designade i Nederländerna, levererade i hela Europa.',
    f_payment:'Säker betalning med',
    cart_title:'Varukorg', cart_empty:'Din varukorg är tom',
    cart_subtotal:'Delsumma', cart_checkout:'Till kassan →',
    cart_note:'Gratis frakt över €299 · Klarna tillgänglig',
    toast_added:'lagd i varukorgen',
    contact_tag:'Kundservice', contact_h1:'Kontakt',
    contact_sub:'Vi svarar inom 24 timmar på vardagar.',
    contact_h2:'Hur kan vi hjälpa?',
    contact_reply:'Svar inom 24 timmar',
    contact_form_h:'Skicka ett meddelande',
    fg_first:'Förnamn', fg_last:'Efternamn', fg_email:'E-postadress',
    fg_order:'Ordernummer (valfritt)', fg_subject:'Ämne', fg_msg:'Meddelande',
    fg_send:'Skicka meddelande',
    about_tag:'Vår historia', about_h1:'Fött ur frustration.',
    about_sub:'För många spelare sitter på otillräckliga stolar. VALCONX är svaret: prisvärt lyx, byggt för att vinna.',
    about_v1h:'Kvalitet framför allt', about_v1t:'Vi använder inga billiga material. Varje komponent vald för hållbarhet.',
    about_v2h:'Rättvist pris', about_v2t:'Genom direktförsäljning från fabrik eliminerar vi mellanhänder.',
    about_v3h:'Community först', about_v3t:'Varje uppdatering kommer från feedback från riktiga användare.',
    about_s1:'Grundat', about_s2:'Sålda stolar', about_s3:'EU-länder', about_s4:'Genomsnittsbetyg',
    about_p_tag:'Hur vi bygger', about_p_h2:'Vår approach', about_p_sub:'Fyra principer i centrum av allt.',
    about_p1h:'Direkt från fabrik', about_p1t:'Vi arbetar direkt med produktionspartners.',
    about_p2h:'Designad av spelare', about_p2t:'Varje modell utvecklad med gaming-communityn.',
    about_p3h:'Transparent service', about_p3t:'30 dagars retur. 2 års garanti. Support inom 24h.',
    about_p4h:'Kontinuerlig förbättring', about_p4t:'Varje VALCONX-generation är bättre än föregående.',
    fg_subj1:'Produktfråga', fg_subj2:'Beställning & leverans', fg_subj3:'Retur & garanti', fg_subj4:'Tekniskt problem', fg_subj5:'Övrigt',
    coll_title:'Gamingstolar',
    coll_sub:'Konstruerade för krävande spelare. Premium komfort, 2 års garanti, gratis returer.',
    coll_filter_all:'Alla', coll_filter_racing:'Racing', coll_filter_pro:'Pro Series', coll_filter_xl:'XL', coll_filter_sale:'Rea',
    coll_compare:'Jämför stolar ↓', coll_help:'Vilken stol passar dig?',
    coll_help_sub:'Använd vår jämförelsetabell längst ner på sidan.',
  }
};

var currentLang = 'nl';

function t(key) {
  var L = TRANSLATIONS[currentLang] || TRANSLATIONS.nl;
  return L[key] !== undefined ? L[key] : (TRANSLATIONS.nl[key] || key);
}

// Apply all translations to page — single sweep via data-i18n attributes
function applyTranslations() {
  var L = TRANSLATIONS[currentLang] || TRANSLATIONS.nl;

  // 1. All [data-i18n] elements — single querySelectorAll, works on ALL pages
  document.querySelectorAll('[data-i18n]').forEach(function(el) {
    var key = el.getAttribute('data-i18n');
    if (L[key] !== undefined) el.textContent = L[key];
  });

  // 2. Nav links via data-nav
  document.querySelectorAll('[data-nav]').forEach(function(el) {
    var key = el.getAttribute('data-nav');
    if (L[key] !== undefined) el.textContent = L[key];
  });

  // 3. Input placeholders
  document.querySelectorAll('[data-i18n-placeholder]').forEach(function(el) {
    var key = el.getAttribute('data-i18n-placeholder');
    if (L[key] !== undefined) el.placeholder = L[key];
  });

  // 4. Announce bar (direct textContent, no data-i18n needed)
  var ann = document.querySelector('.announce');
  if (ann && L.announce) ann.textContent = L.announce;

  // 5. Update html lang attribute
  document.documentElement.lang = currentLang;
}

// ====== LANG SELECTOR ======
function toggleLang(e) {
  if (e) e.stopPropagation();
  document.getElementById('langSelector').classList.toggle('open');
}
function setLang(code, flag, label) {
  currentLang = code;
  try { localStorage.setItem('vx_lang', JSON.stringify({code:code,flag:flag,label:label})); } catch(e){}
  var f = document.getElementById('langFlag'), c = document.getElementById('langCode');
  if (f) f.textContent = flag;
  if (c) c.textContent = label;
  var sel = document.getElementById('langSelector');
  if (sel) sel.classList.remove('open');
  document.querySelectorAll('.mobile-lang-btn').forEach(function(b){ b.classList.remove('active-lang'); });
  var activeBtn = document.getElementById('mlb-'+code);
  if (activeBtn) activeBtn.classList.add('active-lang');
  // Apply static translations
  applyTranslations();
  // Translate dynamic product content if not Dutch
  if (code !== 'nl') {
    translateDynamicContent(code);
  }
}

// ====== DYNAMIC CONTENT TRANSLATION (MyMemory free API) ======
var translationCache = {};

function translateDynamicContent(targetLang) {
  var langMap = {en:'en-GB',fr:'fr-FR',de:'de-DE',es:'es-ES',it:'it-IT',sv:'sv-SE'};
  var apiLang = langMap[targetLang] || targetLang;

  // Elements to translate: product descriptions, names, subtitles
  var selectors = [
    '.pd-name',           // product title
    '.pd-series',         // product series
    '.pd-acc-inner p',    // accordion description paragraphs
    '.pd-acc-inner li',   // accordion list items
    '.coll-prod-desc',    // collection product descriptions
    '.pc-name',           // product card names (only on collection)
    '.coll-hero-title',   // collection page title
    '.coll-hero-sub',     // collection page subtitle
  ];

  selectors.forEach(function(sel) {
    document.querySelectorAll(sel).forEach(function(el) {
      // Skip elements that are already translated or are empty
      var text = el.textContent.trim();
      if (!text || text.length < 3) return;

      // Cache key
      var cacheKey = targetLang + ':' + text.substring(0, 60);
      if (translationCache[cacheKey]) {
        el.textContent = translationCache[cacheKey];
        return;
      }

      // Mark as translating
      el.setAttribute('data-translating', '1');
      el.style.opacity = '0.5';

      // MyMemory API — free, no key needed for low volume
      fetch('https://api.mymemory.translated.net/get?q=' + encodeURIComponent(text) + '&langpair=nl|' + apiLang)
        .then(function(r){ return r.json(); })
        .then(function(data) {
          var translated = data && data.responseData && data.responseData.translatedText;
          if (translated && translated !== text) {
            translationCache[cacheKey] = translated;
            el.textContent = translated;
          }
          el.style.opacity = '1';
          el.removeAttribute('data-translating');
        })
        .catch(function() {
          el.style.opacity = '1';
          el.removeAttribute('data-translating');
        });
    });
  });
}
document.addEventListener('click', function(e) {
  var sel = document.getElementById('langSelector');
  if (sel && !e.target.closest('#langSelector')) sel.classList.remove('open');
});

// ====== MOBILE MENU ======
function toggleMobileMenu() {
  var open = document.getElementById('mobileMenu').classList.contains('open');
  open ? closeMobileMenu() : openMobileMenu();
}
function openMobileMenu() {
  document.getElementById('mobileMenu').classList.add('open');
  document.getElementById('mobileMenuOverlay').classList.add('open');
  document.getElementById('hamburger').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeMobileMenu() {
  document.getElementById('mobileMenu').classList.remove('open');
  document.getElementById('mobileMenuOverlay').classList.remove('open');
  document.getElementById('hamburger').classList.remove('open');
  document.body.style.overflow = '';
}

// ====== CART ======
// ====== CART — INSTANT UPDATE, NO PAGE REFRESH ======

function addToCartAjax(variantId, title, event) {
  if (event) { event.preventDefault(); event.stopPropagation(); }

  if (!variantId || variantId === '' || variantId === 'undefined') {
    showToast(title);
    return;
  }

  // Find the clicked button
  var btn = null;
  if (event && event.target) {
    btn = event.target.closest ? event.target.closest('.add-btn, .pd-add') : (event.target.classList.contains('add-btn') || event.target.classList.contains('pd-add') ? event.target : null);
  }
  var origHTML = btn ? btn.innerHTML : '';
  if (btn) { btn.innerHTML = '⋯'; btn.disabled = true; }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
  })
  .then(function(r) {
    if (!r.ok) throw new Error(r.status);
    return r.json();
  })
  .then(function() {
    if (btn) { btn.innerHTML = origHTML; btn.disabled = false; }
    return fetch('/cart.js').then(function(r){ return r.json(); });
  })
  .then(function(cart) {
    // Step 1: render items into drawer while it's still closed
    updateCartUI(cart);
    // Step 2: show toast notification
    showToast(title);
    // Step 3: now open drawer — items are guaranteed to be visible
    openCartDrawer();
  })
  .catch(function(err) {
    console.error('Cart error:', err);
    if (btn) { btn.innerHTML = origHTML; btn.disabled = false; }
    // Do NOT redirect — show toast with error, stay on page
    showToast(title || 'Product');
    // Try opening cart anyway to show what's already there
    openCartDrawer();
  });
}

function openCartDrawer() {
  var o = document.getElementById('cartOverlay');
  if (o && !o.classList.contains('open')) {
    o.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
}

function toggleCart() {
  var o = document.getElementById('cartOverlay');
  if (!o) return;
  var isOpen = o.classList.contains('open');
  if (isOpen) {
    o.classList.remove('open');
    document.body.style.overflow = '';
  } else {
    o.classList.add('open');
    document.body.style.overflow = 'hidden';
    // Refresh cart data when opening manually
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      updateCartUI(cart);
    });
  }
}

function updateCartUI(cart) {
  // Update all count badges
  var counts = document.querySelectorAll('#cartCount, #mobileCartCount, #cartHeaderCount');
  counts.forEach(function(el) {
    if (el.id === 'cartHeaderCount') {
      el.textContent = cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '');
    } else {
      el.textContent = cart.item_count;
    }
  });
  // Update shipping progress bar
  updateShippingBar(cart.total_price);
  // Render items
  renderCartItems(cart);
}

function updateShippingBar(totalCents) {
  var threshold = 29900; // €299 in cents
  var bar   = document.getElementById('cartShippingBar');
  var text  = document.getElementById('cartShippingText');
  var fill  = document.getElementById('cartShippingFill');
  var left  = document.getElementById('cartShippingLeft');
  if (!bar || !fill) return;

  if (totalCents >= threshold) {
    if (text) text.innerHTML = '✓ Je hebt gratis verzending!';
    if (fill) fill.style.width = '100%';
    fill.style.background = '#2a9a5c';
    bar.style.borderColor = 'rgba(42,154,92,0.3)';
    bar.style.background  = 'rgba(42,154,92,0.06)';
  } else {
    var remaining = ((threshold - totalCents) / 100).toFixed(2).replace('.', ',');
    if (left) left.textContent = remaining;
    var pct = Math.round(totalCents / threshold * 100);
    if (fill) fill.style.width = pct + '%';
    fill.style.background = 'var(--red)';
  }
}

function renderCartItems(cart) {
  var el = document.getElementById('cartItems');
  var footer = document.getElementById('cartFooter');
  if (!el) return;

  if (!cart.item_count) {
    el.innerHTML = '<div class="cart-empty" style="text-align:center;padding:48px 0;color:var(--muted);font-size:14px">'
      + (t('cart_empty') || 'Je winkelwagen is leeg') + '</div>';
    if (footer) footer.style.display = 'none';
    return;
  }

  if (footer) footer.style.display = 'block';

  // Update total
  var tot = document.getElementById('cartTotalDisplay');
  if (tot) tot.textContent = fmt(cart.total_price);

  // Update checkout button
  document.querySelectorAll('.checkout-btn, .checkout-btn-primary').forEach(function(b){ b.href='/checkout'; });

  // Render items
  el.innerHTML = cart.items.map(function(item) {
    var imgHtml = item.image
      ? '<img src="' + item.image + '" alt="' + esc(item.product_title) + '" loading="lazy">'
      : '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:var(--muted);font-size:10px">IMG</div>';

    return '<div class="cart-item">'
      + '<div class="cart-item-img">' + imgHtml + '</div>'
      + '<div class="cart-item-info">'
      + '<div class="cart-item-name">' + esc(item.product_title) + '</div>'
      + (item.variant_title && item.variant_title !== 'Default Title'
          ? '<div class="cart-item-sub">' + esc(item.variant_title) + '</div>' : '')
      + '<div class="cart-item-qty-row">'
      + '<button class="cart-qty-btn" onclick="changeQty(\'' + item.key + '\',' + (item.quantity - 1) + ')" aria-label="Min">−</button>'
      + '<span class="cart-qty-num">' + item.quantity + '</span>'
      + '<button class="cart-qty-btn" onclick="changeQty(\'' + item.key + '\',' + (item.quantity + 1) + ')" aria-label="Plus">+</button>'
      + '</div>'
      + '<div class="cart-item-price">' + fmt(item.line_price) + '</div>'
      + '</div>'
      + '<button class="cart-item-remove" onclick="changeQty(\'' + item.key + '\',0)" aria-label="Verwijder">✕</button>'
      + '</div>';
  }).join('');
}

function changeQty(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function(r){ return r.json(); })
  .then(function(cart){ updateCartUI(cart); });
}

// Close cart on overlay click
document.addEventListener('click', function(e) {
  var o = document.getElementById('cartOverlay');
  if (o && e.target === o) {
    o.classList.remove('open');
    document.body.style.overflow = '';
  }
});

// ====== SLIDER with DOTS ======
var sliderPos = {};
function slideMove(trackId, dir) {
  var track = document.getElementById(trackId);
  if (!track) return;
  var items = track.querySelectorAll('.slider-item');
  if (!items.length) return;
  var state = sliderPos[trackId] || {i:0};
  var vis = getVisible(track);
  var max = Math.max(0, items.length - vis);
  state.i = Math.min(Math.max(state.i + dir, 0), max);
  sliderPos[trackId] = state;
  var iw = items[0].offsetWidth + 1;
  track.style.transform = 'translateX(-' + (state.i * iw) + 'px)';
  updateDots(trackId, state.i, items.length, vis);
}
function getVisible(track) {
  var w = window.innerWidth;
  var isRev = !!track.querySelector('.slider-item--review');
  if (isRev) {
    if (w < 560) return 1;
    if (w < 900) return 2;
    return 3;
  }
  // Bestseller uses CSS grid/wrap — slider JS not needed, return large number
  return 999;
}
function updateDots(trackId, cur, total, vis) {
  var dotsId = trackId.replace('-track', '-dots');
  var dotsEl = document.getElementById(dotsId);
  if (!dotsEl) return;
  var pages = Math.ceil(total / vis);
  var curPage = Math.floor(cur / vis);
  dotsEl.innerHTML = '';
  for (var i = 0; i < pages; i++) {
    var d = document.createElement('button');
    d.className = 'slider-dot' + (i === curPage ? ' active' : '');
    d.setAttribute('data-page', i);
    d.setAttribute('data-track', trackId);
    d.setAttribute('data-vis', vis);
    d.onclick = function() {
      var ti = this.getAttribute('data-track');
      var p = parseInt(this.getAttribute('data-page'));
      var v = parseInt(this.getAttribute('data-vis'));
      var tr = document.getElementById(ti);
      if (!tr) return;
      var its = tr.querySelectorAll('.slider-item');
      var st = sliderPos[ti] || {i:0};
      st.i = p * v;
      sliderPos[ti] = st;
      var iw2 = its[0].offsetWidth + 1;
      tr.style.transform = 'translateX(-' + (st.i * iw2) + 'px)';
      updateDots(ti, st.i, its.length, v);
    };
    dotsEl.appendChild(d);
  }
}
function initSliders() {
  document.querySelectorAll('.slider-track').forEach(function(track) {
    var id = track.id;
    // Init dots
    var items = track.querySelectorAll('.slider-item');
    var vis = getVisible(track);
    updateDots(id, 0, items.length, vis);
    // Touch
    var sx = 0;
    track.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
    track.addEventListener('touchend',function(e){
      var diff = sx - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) slideMove(id, diff > 0 ? 1 : -1);
    },{passive:true});
  });
}
window.addEventListener('resize', function(){
  Object.keys(sliderPos).forEach(function(id){
    sliderPos[id]={i:0};
    var t=document.getElementById(id);
    if(t){t.style.transform='translateX(0)';var its=t.querySelectorAll('.slider-item');var vis=getVisible(t);updateDots(id,0,its.length,vis);}
  });
});

// ====== ACCOUNT ======
function openAccount(){var e=document.getElementById('accountModal');if(e)e.classList.add('open');}
function closeAccount(){var e=document.getElementById('accountModal');if(e)e.classList.remove('open');}
function switchAccountTab(tab,el){
  document.querySelectorAll('.modal-tab').forEach(function(t){t.classList.remove('active');});
  if(el)el.classList.add('active');
  var l=document.getElementById('account-login'),r=document.getElementById('account-register');
  if(l)l.style.display=tab==='login'?'':'none';
  if(r)r.style.display=tab==='register'?'':'none';
}
document.addEventListener('click',function(e){var m=document.getElementById('accountModal');if(m&&e.target===m)closeAccount();});

// ====== PRODUCT FORM ======
// ====== FAQ ======
function toggleFaq(btn){
  var item=btn.parentElement,ans=item.querySelector('.faq-a'),arrow=btn.querySelector('.faq-arrow'),open=item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(function(el){
    el.classList.remove('open');el.querySelector('.faq-a').style.maxHeight='0';
    var ar=el.querySelector('.faq-arrow');if(ar)ar.textContent='+';
  });
  if(!open){item.classList.add('open');ans.style.maxHeight=ans.scrollHeight+'px';if(arrow)arrow.textContent='−';}
}

// ====== TOAST ======
function showToast(name){
  var t=document.getElementById('toast'),m=document.getElementById('toastMsg');
  if(!t)return;
  if(m)m.textContent=(name||'Product')+' — '+t('toast_added');
  t.classList.add('show');setTimeout(function(){t.classList.remove('show');},3000);
}

// ====== UTILS ======
function fmt(c){return '€ '+(c/100).toFixed(2).replace('.',',');}
function esc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
function nlSub(e){e.preventDefault();var b=e.target.querySelector('button');if(b){b.textContent='✓';b.style.background='#1a7a4a';}}

// ====== REVEAL ======
function initReveal(){
  if(!window.IntersectionObserver)return;
  var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting)e.target.classList.add('in');});},{threshold:0.1});
  document.querySelectorAll('.rv:not(.in)').forEach(function(el){obs.observe(el);});
}

// ====== INIT ======
document.addEventListener('DOMContentLoaded', function(){
  // VERTALING: laad opgeslagen taal op ELKE pagina bij elk laden
  try {
    var saved = JSON.parse(localStorage.getItem('vx_lang') || '{}');
    if (saved.code) {
      currentLang = saved.code;
      var flagEl = document.getElementById('langFlag');
      var codeEl = document.getElementById('langCode');
      if (flagEl) flagEl.textContent = saved.flag || '🇳🇱';
      if (codeEl) codeEl.textContent = saved.label || 'NL';
      var activeBtn = document.getElementById('mlb-' + saved.code);
      if (activeBtn) activeBtn.classList.add('active-lang');
      // Apply static UI translations on every page
      setTimeout(function() {
        applyTranslations();
        // Translate dynamic product content if not Dutch
        if (saved.code !== 'nl') {
          translateDynamicContent(saved.code);
        }
      }, 50);
    }
  } catch(e) {}

  // Cart ophalen
  fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
    updateCartUI(cart);
  }).catch(function(){});

  initReveal();
  initSliders();

  // Product form
  var form = document.getElementById('product-form');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var v = document.getElementById('variantId');
      var n = document.querySelector('.pd-name');
      if (v && v.value) {
        addToCartAjax(v.value, n ? n.textContent : 'Product', null);
      } else {
        form.submit();
      }
    });
  }
});
